import * as React from "react";
import { DashboardIcon } from "@teamprevent/common/dashboard";

interface Props {
    href: string;
    text: string;
    iconSource?: string;
}

export class CreateCase extends React.Component<Props> {
    public render() {
        return (
            <DashboardIcon href={this.props.href} icon={this.props.iconSource ? this.props.iconSource : "/assets/create-case.svg"} label={this.props.text} />
        );
    }
}
